import { createContext } from "react";

const BoltClientContext = createContext();

export default BoltClientContext;
